import { render, staticRenderFns } from "./RequestPoliciesInfo.vue?vue&type=template&id=39fdf339&scoped=true&"
import script from "./RequestPoliciesInfo.vue?vue&type=script&lang=js&"
export * from "./RequestPoliciesInfo.vue?vue&type=script&lang=js&"
import style0 from "./RequestPoliciesInfo.vue?vue&type=style&index=0&id=39fdf339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fdf339",
  null
  
)

export default component.exports